module.exports = __webpack_public_path__ + "img/total-costs.6d8f446e.svg";